export enum SoundOption {
  Click1 = "assets/sounds/click1.mp3",
  Click1Hi = "assets/sounds/click1hi.mp3",
  Click2 = "assets/sounds/click2.mp3",
  Click2Lo = "assets/sounds/click2lo.mp3",
  Error = "assets/sounds/error.mp3",
  ErrorEan = "assets/sounds/error_ean.mp3",
  Remove = "assets/sounds/remove.mp3",
  VoucherAddSuccess = "assets/sounds/voucher_add_success.mp3",
  VoucherAddError = "assets/sounds/voucher_add_error.mp3",
  VoucherRemove = "assets/sounds/voucher_remove.mp3",
  PaymentStart = "assets/sounds/payment_start.mp3",
  PaymentSuccess = "assets/sounds/payment_success.mp3",
  PaymentCanceled = "assets/sounds/payment_canceled.mp3",
  PaymentError = "assets/sounds/payment_error.mp3",
  Start = "assets/sounds/start.mp3",
  NextCustomer = "assets/sounds/next_customer.mp3",
}

export const playSound = (selectedSound: SoundOption) => {
  const audio = new Audio(selectedSound);
  audio.play();
};
